import React from 'react';

import { Grid } from '@mui/material';
import _ from 'es-toolkit/compat';

import { Field } from '@hrlogics/react-components/form';

import {
  AutocompleteField,
  CheckboxField,
  DateField,
  DateTimeField,
  SelectField,
  TextField,
} from 'src/components/finalForm';

import type { TableFilter } from './types';

interface TableFilterFieldProps {
  tableFilter: TableFilter;
}

export const TableFilterField: React.FC<TableFilterFieldProps> = ({ tableFilter }) => {
  const { id, type, fieldProps, component, gridItemSize, gridItemProps } = tableFilter;

  const fieldPropsWithComponent = React.useMemo(() => {
    // biome-ignore lint/suspicious/noExplicitAny: one dispatcher for six field components with unrelated prop types; Field infers its props generic from this
    let component: React.FC<any> = TextField;

    switch (type) {
      case 'text':
        component = TextField;
        break;
      case 'select':
        component = SelectField;
        break;
      case 'date':
        component = DateField;
        break;
      case 'dateTime':
        component = DateTimeField;
        break;
      case 'autocomplete':
        component = AutocompleteField;
        break;
      case 'checkbox':
        component = CheckboxField;
        break;
      case 'custom':
        // Custom filters render their own element via the early return below;
        // no default field component is needed.
        break;
      default:
        throw new Error('Unsupported table filter field type');
    }

    return {
      component,
      ...fieldProps,
    };
  }, [type, fieldProps]);

  if (type === 'custom' && !_.isNil(component)) {
    return component;
  }

  return (
    <Grid size={{ xs: gridItemSize || 12 }} {...gridItemProps}>
      <Field name={id} fullWidth {...fieldPropsWithComponent} />
    </Grid>
  );
};
